import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal, BadgeGroup } from 'containers/misc'
import { Title } from 'components/layout'
import { injectIntl } from 'react-intl'
import { apiMessages } from 'helpers/decorators/api'
import { Button } from '../../misc'
import { get } from 'lodash'


@apiMessages()
@injectIntl
class GroupBadgeOverviewModal extends Component {
  static propTypes = {
    modalId: PropTypes.string,
    intl: PropTypes.object.isRequired,
    modal: PropTypes.func,
    badges: PropTypes.object.isRequired,
    awardBadges: PropTypes.object.isRequired,
    badgesProgress: PropTypes.object.isRequired,
    award: PropTypes.object.isRequired,
    badge: PropTypes.object.isRequired,
    activity: PropTypes.object.isRequired,
    isBadgesStrictModeEnabled: PropTypes.object.isRequired
  }

  render() {
    const {
      modalId,
      badges,
      awardBadges,
      badgesProgress,
      award,
      activity,
      badge,
      isBadgesStrictModeEnabled
    } = this.props

      const badgeName = get(badge, 'name.value')

      const badgesData = get(badges, 'badges') && get(badges, 'badges')[badgeName]

      const badgeByName =  get(badgesData, 'badges')

      const groupName = badgeByName && badgeByName.length > 0 && get(badgeByName[0], 'badgeGroup.name.translationText')

    return (
      <Modal id={modalId} customActions>

        <div className="text--center">
          <Title h2 intlKey="title.badge_details">
              {groupName}
          </Title>
        </div>

        <div className="col-xs-12">
          <BadgeGroup
              badge={badge}
              badges={badges}
              awardBadges={awardBadges}
              badgesProgress={badgesProgress}
              award={award}
              activity={activity}
              isBadgesStrictModeEnabled={isBadgesStrictModeEnabled}
          />
        </div>

        <div className="row base-margin--top">
          <div className="col-xs-12" style={{ textAlign: 'center' }}>
              <Button
                  type="button"
                  onClick={() => this.props.modal(null)}
                  intlKey="button.close"
                  secondary
              >
                Close
              </Button>
          </div>
        </div>
      </Modal>
    )
  }
}

export default GroupBadgeOverviewModal
